import axios from 'axios'
import {Store} from 'vuex'

export default class LoginService {
  constructor(private store: Store<any>) {
    this.store = store
  }

  public loginIhm(loc = window.location) {
    this.store.commit('loggingIhm')
    const port = loc.port ? `:${loc.port}` : ''
    const context = loc.pathname.split('/')
    // If you have configured multiple OIDC providers, then, you can update this URL to /login.
    // It will show a Spring Security generated login page with links to configured OIDC providers.
    loc.href = `//${loc.hostname}${port}/${context[1]}/loginsad/oauth2_login_ihm`
  }

  public loginPtddt(loc = window.location) {
    this.store.commit('loggingPtddt')
    const port = loc.port ? `:${loc.port}` : ''
    const context = loc.pathname.split('/')
    // If you have configured multiple OIDC providers, then, you can update this URL to /login.
    // It will show a Spring Security generated login page with links to configured OIDC providers.

    loc.href = `//${loc.hostname}${port}/${context[1]}/loginsad/oauth2_login_ptddt`
  }

  public logout(): Promise<any> {
    // TODO logout pas encore géré très bien par Gina...
    this.store.commit('logout')
    return axios.post('logout')
  }
}
